/**
 * Get the elements offset from the top of the page.
 * Note: this changes as we scroll.
 * @param {Object} element The element to find the top position of
 * @returns {Number} The number of pixels from the top.
 */
export const getOffsetTop = (element) => {
    if (element instanceof Element) {
        return element.getBoundingClientRect().top;
    }
    return 0;
};

/**
 * Get the elements offset from the top of the entire document (regardless of scroll position)
 * @param {Object} element The element to find the top position of
 * @returns {Number} The number of pixels from the absolute top.
 */
export const getOffsetTopWindow = (element) => {
    return getOffsetTop(element) + window.scrollY;
};

/**
 * Window height helper method
 * @returns {Number} The window's height.
 */
export const getWindowHeight = () => {
    return window.document.documentElement.clientHeight;
};

/**
 * Get an elements height.
 * @param {Object} element The element to find the height of
 * @param {Boolean} outerHeight Determines whether you want to return the outerheight or not
 * @returns {Number} A number of pixels height
 */
export const getElementHeight = (element, outerHeight = false) => {
    if (!element) {
        return 0;
    }
    if (element.nodeType === 9) {
        return _getDocumentHeight();
    }
    return outerHeight ? _getOuterHeight(element) : element.clientHeight;
};

/**
 * Returns the document width
 * @returns {Number} The max between all the various width properties
 * @private
 */
export const getDocumentWidth = () => {
    const docElement = document.documentElement;
    return Math.max(
        document.body.offsetWidth, docElement.offsetWidth,
        docElement.clientWidth
    );
};

/**
 * PRIVATE METHODS ---------------------
 */
/**
 * Returns the document height
 * @returns {Number} The max between all the various height properties
 * @private
 */
const _getDocumentHeight = () => {
    const docElement = document.documentElement;
    return Math.max(
        document.body.scrollHeight, docElement.scrollHeight,
        document.body.offsetHeight, docElement.offsetHeight,
        docElement.clientHeight
    );
};
/**
 * Retrieves the outer height of an element, including
 * @param {Object} element The element
 * @returns {Number} The outerHeight of an element, including margin
 * @private
 */
const _getOuterHeight = (element) => {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
};
